var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 51,
    viewBox: "0 0 89 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2275 50.3482V27.3134L88.4401 0.734863L26.2275 50.3482Z",
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2275 50.3482L35.0675 36.7016L88.325 0.734863L26.2275 50.3482Z",
    fill: "#FFF7D1",
    stroke: "#292B2E",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0956 32.0222L2.71077 18.9958C2.00214 18.601 2.17156 17.5369 2.96773 17.3817L88.3896 0.734863L26.0956 32.0222Z",
    fill: "#FFF7D1",
    stroke: "#292B2E",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5002 50.3553L35.0879 36.6159L88.3258 0.734863L64.663 49.949C64.4545 50.3827 63.9335 50.5648 63.5002 50.3553Z",
    fill: "#FFF7D1",
    stroke: "#292B2E",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/PaperPlane.42f9ecadb3b8629ec879ec33dcc5e80b.svg";
export { ForwardRef as ReactComponent };